export const TABLET_SIZE = 768
export const MAX_TABLET_DEVICE_WIDTH = 1024
